import { useLoaderData } from "react-router-dom";

import AppWrapper from "../../components/cm/AppWrapper";
import SideBarMain from "../../components/cm/SideBarMain/SideBar";
import ViewManagement from "../../components/modules/dynamic-views/view-management/ViewManagement";

export default function Template() {
  const { viewName, id } = useLoaderData();

  return (
    <AppWrapper.WithSidebar sidebar={<SideBarMain />}>
      <ViewManagement/>
    </AppWrapper.WithSidebar>
  );
}
